'use client'

import { ReactNode } from 'react'

export interface HomeProps {
  children: ReactNode
}

export default function Home({ children }: HomeProps) {
  return <main className="layout">{children}</main>
}
